import React from "react";
import { AssessmentConfiguration, AssessmentParameter, SimulationValidationError } from "src/types/coaching/simulation";

export interface SimulationContextProps {
  id?: string;
  validationError?: SimulationValidationError;

  // eslint-disable-next-line no-unused-vars
  gotoError?(error?: SimulationValidationError): void;

  // eslint-disable-next-line no-unused-vars
  editPersona?: (value: any) => void;

  // eslint-disable-next-line no-unused-vars
  editObjectives?: (value: any) => void;

  // eslint-disable-next-line no-unused-vars
  editOrganizationInfo?: (value: any) => void;

  // eslint-disable-next-line no-unused-vars
  editAssessmentParameter?: (value: AssessmentParameter | null) => void;

  // eslint-disable-next-line no-unused-vars
  editAssessmentScoreCard?: (value: boolean) => void;

  // eslint-disable-next-line no-unused-vars
  activeAssessmentScorecard?: AssessmentConfiguration | null;

  // eslint-disable-next-line no-unused-vars
  setActiveAssessmentScorecard?: (scorecard: AssessmentConfiguration | null) => void;
  
}

export const SimulationContext = React.createContext<SimulationContextProps>({
  
});
